module.exports = __webpack_public_path__ + "static/media/gettips_logo_purple.c3f32904.svg";